import {gsap} from "gsap";
import {Flip} from "gsap/Flip";
import { lenis } from './main.js'


gsap.registerPlugin(Flip);
let imgFlip;

export const TransitionProduct = {
    name: 'typo-product',
    from: {
        namespace: [
            'tipologia'
        ]
    },
    to: {
        namespace: [
            'prodotto'
        ]
    },
    leave(data) {



        return new Promise(resolve => {


            imgFlip = data.trigger.querySelector('img');

            let flipState = Flip.getState(imgFlip);


            gsap.set(imgFlip.parentNode,{
                height : () => {
                    return imgFlip.parentNode.clientHeight;
                },
                width : () => {
                    return imgFlip.parentNode.clientWidth;
                }
            })



            document.querySelector('.transition-overlay').append(imgFlip);



            gsap.to('.transition-slide',{
                yPercent: 0,
                y: 0,
                ease: "expo.out",
                duration: 1.5
            })



            gsap.to(data.current.container,{
                opacity:0,
                duration: 2,
                ease: "expo.out",
            })

            Flip.from(flipState, {
                duration: 2,
                ease: "expo.out",
                absolute: true,
                onComplete: () => {



                    lenis.scrollTo(0, { immediate: true })
                    lenis.stop()



                    data.current.container.classList.add('d-none');
                    resolve()




                }
            });




        })







    },
    enter(data) {


        return new Promise(resolve => {




            gsap.set('.block-prodtop__image-wrap img',{
                opacity:0
            })

            gsap.set('.block-prodtop__t span',{
                yPercent: 100
            })

            gsap.set('.block-prodtop__txt',{
                opacity: 0
            })

            gsap.set('.block-prodtop .breadcrumb',{
                opacity: 0
            })



            gsap.to('.transition-slide',{
                yPercent: -100,
                ease: "expo.out",
                duration: 1.5,
                onComplete: () => {


                    document.querySelector('.header').classList.add('inverted');
                    document.querySelector('.header').classList.remove('hide');
                    document.querySelector('.header').classList.remove('sticky');

                    gsap.set('.transition-slide',{
                        clearProps: 'all',
                    })


                    const newFlipState = Flip.getState(imgFlip);

                    const targetDiv = data.next.container.querySelector('.block-prodtop__image-cover');
                    targetDiv.innerHTML = '';

                    targetDiv.appendChild(imgFlip);




                    Flip.from(newFlipState, {
                        duration: 2,
                        ease: "expo.out",
                        onComplete : () => {
                            document.body.classList.remove('wait');
                            resolve();
                        }
                    });

                    gsap.to('.block-prodtop__t span',{
                        yPercent: 0,
                        y: 0,
                        delay: .5,
                        duration: 2,
                        ease: "expo.out",
                    })

                    gsap.to('.block-prodtop__txt',{
                        opacity:1,
                        delay: 1,
                        duration: 2,

                    })

                    gsap.to('.block-prodtop .breadcrumb',{
                        opacity:1,
                        delay: 1,
                        duration: 2,

                    })




                    lenis.start()
                    console.log('qua')

                }
            })






        })

    },
    afterEnter(data) {

    }
}
